module.exports = __webpack_public_path__ + "fonts/icon-original.365008c.woff";